module.exports = __webpack_public_path__ + "static/img/wisdomPlanLeft.9c50a48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wisdomPlanLeft.png
// module id = KIE0
// module chunks = 2